import PropTypes from "prop-types";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import Skeleton from "react-loading-skeleton";
import { FormattedMessage } from "react-intl";
const StaticTable = ({
  columns,
  data = [],
  customClass,
  defaultErrorMessage,
  messageId,
  loading = false,
  setIsProfileHistoryOpen,
  setSelectedConsent,
  clickableRow = true,
}) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <div className="commonTable custom-Table" id="dataSubjectTable">
      <table className={`table ${customClass} ? customClass :"`}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {loading ? (
          <tbody>
            {[1, 2, 3, 4, 5]?.map((row) => (
              <tr key={row}>
                {Array(columns?.length)
                  .fill(1)
                  ?.map((_, colIndex) => (
                    <td key={colIndex}>
                      <Skeleton animation="wave" variant="text" />
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            {table.getRowModel().rows.length === 0 ? (
              <tr>
                <td
                  colSpan={columns?.length}
                  className="fs-5 py-2 text-center fw-bold text-danger"
                  id="exampleModalLongTitle"
                >
                  <FormattedMessage
                    id={messageId}
                    defaultMessage={defaultErrorMessage}
                  />
                </td>
              </tr>
            ) : (
              table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className={clickableRow ? "clickable" : "non-clickable"}
                  onClick={() => {
                    if (setIsProfileHistoryOpen) setIsProfileHistoryOpen(true);
                    if (setSelectedConsent) setSelectedConsent(row?.original);
                  }}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        )}
      </table>
    </div>
  );
};

StaticTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  customClass: PropTypes.string,
  defaultErrorMessage: PropTypes.string,
  messageId: PropTypes.string,
  loading: PropTypes.bool,
  setIsProfileHistoryOpen: PropTypes.func,
  setSelectedConsent: PropTypes.func,
  clickableRow: PropTypes.bool,
};

export default StaticTable;